// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* ── Embedded (inline) mode ──────────────────────────────────────────────
   Renders the chat inside a page container (the Overview playground) rather
   than as a fullscreen overlay: it fills its parent, drops the backdrop and
   close button, and lets its inner column flex to the available height. */
.chat-modal.embedded {
  position: relative;
  inset: auto;
  top: auto;
  left: auto;
  width: 100%;
  height: 100%;
  display: block;
  z-index: auto;
}
.chat-modal.embedded .chat-modal-overlay {
  display: none;
}
.chat-modal.embedded .chat-modal-close-btn {
  display: none;
}
.chat-modal.embedded .chat-modal-content {
  width: 100%;
  max-width: none;
  height: 100%;
  /* Include the 10px padding (and 1px border) in the 100% height — without
     border-box the padding is ADDED to 100%, so the chat overflows its cell
     by ~20px and the playground ends up taller than the right column. */
  box-sizing: border-box;
  border: 1px solid #e5e7eb;
  box-shadow: none;
}
.chat-modal.embedded .chat-parent {
  max-width: none;
}
/* Main chat: fill the space below the header inside the flex column. */
.chat-modal.embedded .chat-modal-content > .chat-parent {
  height: auto;
  flex: 1 1 auto;
  min-height: 0;
}
/* Upgrade-locked state renders .chat-parent directly under .chat-modal. */
.chat-modal.embedded > .chat-parent {
  height: 100%;
}
/* Make the embedded chat a strict, shrinkable flex column: min-height:0 lets the
   message list shrink below its content and scroll internally, and the input is
   pinned (flex-shrink:0) so it stays visible at the bottom on any viewport. Without
   min-height:0 the message list pushes the input out of the clipped box on short
   (mobile) viewports — that was the "no input visible" bug. */
.chat-modal.embedded .chat-parent,
.chat-modal.embedded .logo-messages-container,
.chat-modal.embedded .message-container {
  min-height: 0;
}
.chat-modal.embedded .chat-input {
  flex-shrink: 0;
}

.chat-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.chat-modal-content {
  position: relative;
  z-index: 1001;
  width: 95%;
  max-width: 750px;
  height: 80vh;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  padding: 10px;
  padding-bottom: 10px;
}

.chat-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 2px 0px 8px 8px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 4px;
}

.chat-modal-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.chat-modal-header-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.chat-modal-header-title {
  font-size: 16px;
  font-weight: 600;
  color: #20202a;
  line-height: 1.2;
}

/* Subtitle under the title — mirrors the Overview "Live chat" subtitle
   (.ov-action-sub): small, muted. */
.chat-modal-header-sub {
  font-size: 12px;
  color: #82828e;
  line-height: 1.3;
}

/* Purple rounded-square icon before the title — mirrors the Overview's
   ".ov-action-ic" (Live chat) style so the two read as a set. */
.chat-modal-header-ic {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #f3f0fc;
  color: #5616ea;
  font-size: 14px;
  flex-shrink: 0;
}

/* Right-side header controls (Clear + close), kept together on the title
   line via the header's space-between. */
.chat-modal-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.chat-modal-clear-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  color: #5616ea;
  background: #f4f1fd;
  border: 1px solid #e7defb;
  border-radius: 7px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.chat-modal-clear-btn:hover:not(:disabled) {
  background: #ece5fb;
  border-color: #d7c6f6;
}

.chat-modal-clear-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chat-modal-clear-btn svg {
  font-size: 11px;
}

.chat-modal-close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #888;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
  line-height: 1;
}

.chat-modal-close-btn:hover {
  background: #f0f0f0;
  color: #333;
}

.chat-modal-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.chat-modal-spinner {
  font-size: 40px;
  color: #5616ea;
}

.text-container {
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-top: 10px;
  margin-right: 50px;
  margin-bottom: 10px;
}

.text-container p {
  margin: 0;
  line-height: 1.5;
  font-size: 14px;
}

.word {
  font-weight: bold;
  margin: 0;
  padding: 0;
  margin-right: 1px;
  font-size: 19.5px;
  color: #5616ea;
  line-height: 1.1;
}

.chat-parent {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-width: 800px;
  background-color: white;
  overflow: hidden;
}

.chat-knowledge-banner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  background-color: #fff9e1;
  border-left: 4px solid #ffc107;
  border-radius: 8px;
  padding: 10px 12px 12px 12px;
  margin: 0 10px 12px 10px;
  color: #554002;
  font-size: 14px;
  line-height: 1.4;
}

.chat-knowledge-banner-textrow {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-knowledge-banner p { margin: 0; }

.chat-knowledge-banner-icon {
  font-size: 20px;
  color: #ffc107;
  flex-shrink: 0;
}

.manage-knowledge-button {
  background: #fff;
  border: 1px solid #e4d59c;
  color: #554002;
  font-weight: 600;
  cursor: pointer;
  padding: 6px 14px;
  font-size: 13px;
  border-radius: 6px;
  box-shadow: 0 0 0 0 rgba(0,0,0,0);
  transition: background-color .15s ease, transform .15s ease, box-shadow .2s ease;
}

.manage-knowledge-button:hover {
  background: #ffeaa3;
  transform: translateY(-1px);
}

.manage-knowledge-button:active {
  transform: translateY(0);
}

.logo-messages-container {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  overflow: hidden;
}

.message-container {
  position: relative;
  flex: 1 1;
  overflow-y: auto;
  margin-right: -10px;
}

.message {
  display: flex;
  flex-direction: row;
  color: white;
  border-radius: 10px;
  padding: 10px;
  padding-top: 5px;
  padding-bottom: 8px;
  margin-bottom: 5px;
}

.user-message {
  justify-content: flex-end;
}

.bot-message {
  justify-content: flex-start;
}

.user-message p, .bot-message p {
  margin: 0;
  padding: 0;
}

.user-icon {
  height: 32px;
  width: 32px;
  margin-left: 8px;
  margin-top: 2px;
}

.bot-left-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 8px;
  height: 40px;
  width: 40px;
  background-color: #5616ea;
  border-radius: 150px;
  flex-direction: column;
}

.bot-left-icon-text {
  margin-bottom: 6px;
  margin-right: 0.5px;
}

.scf-logo-top {
  height: 65px;
}

.bot-chat-text,
.user-chat-text {
  max-width: 70%;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1.5;
  background: #fff;
  color: #333;
  padding: 7px;
}

.bot-chat-text a {
  color: #5616ea;
  font-weight: 500;
  text-decoration: underline;
}

/* ------------- paragraphs ------------ */
.bot-chat-text p {
  margin: 0 0 .9em;            /* .6em gap after each paragraph */
}

/* ------------- headings: match paragraph size ------------ */
.bot-chat-text h1,
.bot-chat-text h2,
.bot-chat-text h3,
.bot-chat-text h4,
.bot-chat-text h5,
.bot-chat-text h6 {
  font-size: 1em;              /* same as paragraph (container's 16px) */
  line-height: inherit;
  margin: 0 0 .9em;            /* align spacing with paragraphs */
}

/* ------------- lists ------------ */
.bot-chat-text ul,
.bot-chat-text ol {
  margin: .9em 0;              /* same top-/bottom gap */
  padding-left: 1.25em;        /* indent bullets */
}

.bot-chat-text li {
  margin: .25em 0;             /* tighten bullet-to-bullet spacing */
}

/* ------------- tables ------------ */
.bot-chat-text table {
  margin: .9em 0;              /* no more 15px canyon */
}

.bot-chat-text > :first-child {
  margin-top: 0;
  padding-top: 0;
}

.bot-chat-text > :last-child {
  margin-bottom: 0;
  padding-top: 0;
}

.user-chat-text {
  background-color: #f2f2f2;
  border: none;
  text-align: left;
  color: #000000;
  padding: 7px;
  border-radius: 10px;
}

.send-icon {
  width: 16px;
  height: 16px;
  fill: currentColor;
  display: block;
}

.chat-input {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  border-top: 1px solid #f1f1f1;
  padding: 10px;
  background-color: #fafafa;
}

.chat-input textarea {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  font-size: 16px;
  resize: none;
  line-height: 1.4;
  max-height: 140px;
  overflow-y: hidden;
  font-family: "DM Sans", sans-serif;
  box-sizing: border-box;
}

.chat-input textarea.has-overflow {
  overflow-y: auto;
}

.loading-dots {
  display: flex;
  justify-content: left;
  align-items: center;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 5px;
  margin-left: 10px;
}

.loading-dots div {
  width: 8px;
  height: 8px;
  margin: 0 4px;
  border-radius: 50%;
  background-color: #5616ea;
  animation: loading-bounce 0.6s infinite alternate;
}

@keyframes loading-bounce {
  to {
    opacity: 0.3;
    transform: translateY(-8px);
  }
}

.loading-dots div:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots div:nth-child(3) {
  animation-delay: 0.4s;
}

.input-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  height: 34px;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  background-color: #5616ea;
  transition: background-color 0.4s ease, transform 0.2s ease;
}

.input-button:hover {
  background-color: #4a14d6;
  transform: translateY(-1.5px);
}

/* table styles */
.message table {
  border-collapse: separate;
  border-spacing: 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  overflow: auto;
}

.message th, .message td {
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: .35rem .50rem;
  text-align: left;
  font-size: 14px;
}

.message th {
  color: #000000;
  background-color: rgba(0, 0, 0, 0.06);
  border-right: 0;
  padding: .5rem .50rem;
}

.message th:last-child {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
}

.message th {
  border-bottom: none;
}

.message td {
  border-bottom: 0px solid rgba(0, 0, 0, 0.08);
}

.message td {
  border-right: 0px solid rgba(0, 0, 0, 0.08);
}

.message td:last-child {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
}

.message tr:first-child th:first-child {
  border-top-left-radius: 8px; /* Rounded top left corner */
}
.message tr:first-child th:last-child {
  border-top-right-radius: 8px; /* Rounded top right corner */
}
.message tr:last-child td:first-child {
  border-bottom-left-radius: 8px; /* Rounded bottom left corner */
}
.message tr:last-child td:last-child {
  border-bottom-right-radius: 8px; /* Rounded bottom right corner */
}

.message tr:last-child td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08); /* Adds bottom border back on all cells of the last row */
}
/*Table style ending*/

.upgrade-locked-container {
  position: relative;
  z-index: 1001;
  width: 95%;
  max-width: 450px;
  max-height: 150px;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  padding: 10px;
  gap: 10px;
}

.upgrade-button {
  background-color: #5616ea;
  color: white;
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  transition: 0.2s ease, color 0.2s ease;
}

.upgrade-button:hover {
  background-color: #4a14d6;
  transform: translateY(-1px);
}

/* ── Upgrade-locked overlay ───────────────────────────────────────────────
   At the message limit we keep the full chat (same structure + size) but lay
   one frosted scrim over the WHOLE content — header included — and float a
   premium upgrade card on it. The only live control is a clean, background-less
   close button (Test Agent modal only; the embedded Overview playground has no
   close). */
.chat-modal-content.is-locked > .chat-parent {
  pointer-events: none;
}
/* The header is blurred behind the frost; hide its live buttons (Clear + the
   built-in close) so they don't show as a smudge behind the single floating
   close button below. The title stays, softly blurred. */
.chat-modal-content.is-locked .chat-modal-header-actions {
  visibility: hidden;
}

.chat-locked-overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  /* Faint brand-tinted frost so the chat reads as "behind glass". */
  background: rgba(247, 245, 255, 0.6);
  backdrop-filter: blur(5px) saturate(115%);
  border-radius: 10px;
}

/* Floating close — sits on the frost, no background, just the glyph. */
.chat-locked-close {
  position: absolute;
  top: 12px;
  right: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  background: transparent;
  color: #6b6b78;
  font-size: 18px;
  line-height: 1;
  border-radius: 9px;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease;
}
.chat-locked-close:hover {
  color: #20202a;
  background: rgba(86, 22, 234, 0.08);
}

.chat-locked-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 360px;
  padding: 34px 30px;
  background: #ffffff;
  border: 1px solid #efeafd;
  border-radius: 18px;
  box-shadow:
    0 24px 50px -18px rgba(86, 22, 234, 0.30),
    0 2px 6px rgba(20, 10, 50, 0.05);
}

.chat-locked-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6a2bff 0%, #5616ea 100%);
  color: #ffffff;
  font-size: 22px;
  box-shadow: 0 10px 22px -6px rgba(86, 22, 234, 0.55);
}

.chat-locked-title {
  margin: 20px 0 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #1d1b2e;
}

.chat-locked-sub {
  margin: 8px 0 0;
  max-width: 280px;
  font-size: 14px;
  line-height: 1.5;
  color: #6b6b78;
}

.chat-locked-btn {
  margin-top: 22px;
  padding: 11px 30px;
  border-radius: 10px;
  font-size: 15px;
  box-shadow: 0 10px 22px -8px rgba(86, 22, 234, 0.6);
}
.chat-locked-btn:hover {
  box-shadow: 0 12px 26px -8px rgba(86, 22, 234, 0.7);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .chat-modal-content {
    margin: 10px;
    padding-left: 0;
    padding-right: 0;
  }

  .chat-parent {
    display: flex;
    height: 90vh;
    justify-content: center;
  }

  /* Embedded playground (Overview): the fullscreen-modal mobile sizing above
     breaks it — the content margin pushes the input below its clipped parent,
     and the fixed chat-parent/message-container heights fight the flex layout.
     Neutralise them so the embedded chat fills its cell and the input stays
     visible at the bottom. */
  .chat-modal.embedded .chat-modal-content {
    margin: 0;
    /* Restore the side gutter the fullscreen-modal mobile rule strips
       (padding-left/right:0), so the header's Clear button and the messages
       keep space from the playground border. */
    padding-left: 10px;
    padding-right: 10px;
  }
  .chat-modal.embedded .chat-parent {
    height: auto;
    justify-content: flex-start;
  }
  .chat-modal.embedded .message-container {
    height: auto;
  }

  .user-message {
    max-width: 92%;
  }

  .logo-messages-container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .text-container {
    margin-right: 0px;
  }

  .chat-input {
    width: 95%;
  }

  .bot-icon {
    height: 24px;
    min-width: 24px;
  }

  .scf-icon {
    width: 30px;
    height: 30px;
    margin-top: -2px;
  }

  .loader {
    margin-left: 10px;
  }

  .message-container {
    height: 83%;
  }
}

/* allow children (icon, bubble, CTA) to wrap to a new line */
.message {
  align-items: flex-start;
  flex-wrap: wrap;
}

/* In-chat product gallery: breaks to its own full-width line under the reply
   text (the bot message row is flex-wrap). box-sizing + padding-left indents the
   cards to line up past the 40px agent avatar without overflowing the row. */
.ub-pc-inline {
  flex-basis: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-left: 48px;
  margin-top: 4px;
}

/* When the gallery sits between the reply and the Q&A helper, keep the helper's
   indent (its usual adjacency selector no longer matches). */
.ub-pc-inline + .qa-cta {
  margin-left: 48px;
}

@media (max-width: 768px) {
  .ub-pc-inline {
    padding-left: 8px;
  }
}

.qa-cta {
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0px;
  gap: 3px;
  margin-left: 0;
  padding-top: 5px;
}

.qa-span-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.qa-cta span{
  color: #373737;
  font-size: 10px;
}

.message .scf-icon-container + .bot-chat-text + .qa-cta {
  margin-left: 48px;
}

.qa-cta .add-faq-button {
  background: transparent;
  border: 1px solid #e0e0e0;
  padding: 4px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  color: #5616ea;
}

.qa-cta .add-faq-button:hover {
  background: #f4f4f4ff;
}

.qa-lighbulb-icon {
  margin-right: 2px;
  font-size: 12px;
}

.message-usage-row {
  padding: 0 12px 0px 12px;
  margin-top: 8px;
}

.message-usage-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  column-gap: 20px;
  row-gap: 2px;
  align-items: center;
  width: 40%;
}

.message-usage-text {
  font-size: 10px;
  color: #555;
  line-height: 1.2;
}

.message-plan-name {
  font-size: 10px;
  color: #555;
  line-height: 1.2;
  text-align: left;
  justify-self: start;
}

.message-usage-text--danger {
  color: #d53535;
  font-weight: 600;
}

.message-usage-bar {
  height: 3px;
  background-color: #e6e6e6;
  border-radius: 3px;
  overflow: hidden;
  width: 180px;
  min-width: 120px;
}

.message-usage-fill {
  height: 100%;
  background-color: #5616ea;
  transition: width 0.3s ease;
}

.message-usage-cta {
  padding: 5px 12px;
  font-size: 11px;
  line-height: 1;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #ffffff;
  color: #333;
  cursor: pointer;
  transition: transform 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
  justify-self: start;
}

.message-usage-cta:hover {
  background: #f6f6f6;
  transform: translateY(-1px);
}

.message-usage-cta:active {
  transform: translateY(0);
}

.message-usage-cta--attention {
  border-color: #d53535;
  color: #d53535;
}

@media (max-width: 768px) {
  .message-usage-row {
    padding-left: 10px;
    padding-right: 10px;
  }
  .message-usage-grid {
    column-gap: 8px;
    width: 70%;
  }
  .message-usage-bar {
    width: 140px;
    min-width: 100px;
  }
  .message-usage-cta {
    padding: 6px 10px;
    font-size: 11px;
  }
}

/* ——— busy/disabled visuals ——— */
.input-button[disabled] {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

/* Scroll-to-bottom floating button */
.scroll-to-bottom-btn {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  background: rgba(255, 255, 255, 0.95);
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: background-color 0.15s ease, box-shadow 0.2s ease;
  z-index: 5;
  animation: scroll-btn-fade-in 0.2s ease both;
}

.scroll-to-bottom-btn:hover {
  background: #f0f0f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.scroll-to-bottom-btn:active {
  background: #e8e8e8;
}

@keyframes scroll-btn-fade-in {
  from { opacity: 0; transform: translateX(-50%) translateY(6px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

.chat-input textarea:disabled {
  background: #f5f5f5 !important;
  cursor: not-allowed !important;
}

.predefined-question.is-disabled {
  opacity: 0.5 !important;
  pointer-events: none !important;
}

.voice-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #f8f4ff 0%, #efe8ff 100%);
  color: #5616ea;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(86, 22, 234, 0.1);
}

.voice-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #5616ea 0%, #7c3aed 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  transition-delay: 0s;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(86, 22, 234, 0.3);
  z-index: 100;
}

.voice-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #7c3aed;
}

.voice-button:hover .voice-tooltip {
  opacity: 1;
  visibility: visible;
  transition-delay: 0.3s;
}

.voice-button.voice-active .voice-tooltip {
  display: none;
}

.voice-button:hover:not([disabled]) {
  background: linear-gradient(135deg, #f0e8ff 0%, #e4d8ff 100%);
  transform: translateY(-1.5px);
  box-shadow: 0 3px 8px rgba(86, 22, 234, 0.15);
}

.voice-button:active:not([disabled]) {
  transform: translateY(0);
}

.voice-button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.voice-button.voice-active {
  background: linear-gradient(135deg, #5616ea 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(86, 22, 234, 0.3);
}

.voice-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
}

.voice-overlay-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #0a0a0f 0%, #12121a 50%, #0a0a0f 100%);
  z-index: 0;
}

.voice-status-dot {
  position: absolute;
  top: 40px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #5616ea;
  animation: status-dot-pulse 2s ease-in-out infinite;
  z-index: 1;
}

@keyframes status-dot-pulse {
  0%, 100% { opacity: 0.4; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
}

.voice-initializing-spinner {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  margin-bottom: 40px;
  font-size: 48px;
  color: #5616ea;
}

.voice-visualizer-container {
  position: relative;
  z-index: 1;
  width: 280px;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
}

.voice-blob {
  position: relative;
  width: 180px;
  height: 180px;
  transition: transform 0.1s ease-out;
}

.voice-blob-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 140px;
  height: 140px;
  background: radial-gradient(circle at 30% 30%, #ffffff 0%, #f0f0f0 50%, #e0e0e0 100%);
  border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;
  box-shadow:
    0 0 60px rgba(86, 22, 234, 0.3),
    0 0 100px rgba(86, 22, 234, 0.2),
    inset 0 0 30px rgba(255, 255, 255, 0.5);
  animation: blob-morph 4s ease-in-out infinite;
}

.voice-blob-initializing .voice-blob-inner {
  animation: blob-initializing 1.2s ease-in-out infinite;
  background: radial-gradient(circle at 30% 30%, #f3e8ff 0%, #e9d5ff 50%, #ddd6fe 100%);
  box-shadow:
    0 0 60px rgba(86, 22, 234, 0.4),
    0 0 100px rgba(86, 22, 234, 0.2),
    inset 0 0 30px rgba(255, 255, 255, 0.5);
}

.voice-blob-initializing .voice-blob-ring {
  border-color: rgba(86, 22, 234, 0.3);
  animation: ring-pulse-slow 2.5s ease-out infinite;
}

.voice-blob-listening .voice-blob-inner {
  animation: blob-morph-active 1.5s ease-in-out infinite;
  box-shadow:
    0 0 80px rgba(86, 22, 234, 0.5),
    0 0 120px rgba(86, 22, 234, 0.3),
    inset 0 0 30px rgba(255, 255, 255, 0.5);
}

.voice-blob-thinking .voice-blob-inner {
  animation: blob-thinking 1s ease-in-out infinite;
  background: radial-gradient(circle at 30% 30%, #fff8e1 0%, #ffecb3 50%, #ffe082 100%);
  box-shadow:
    0 0 80px rgba(255, 193, 7, 0.5),
    0 0 120px rgba(255, 193, 7, 0.3),
    inset 0 0 30px rgba(255, 255, 255, 0.5);
}

.voice-blob-speaking .voice-blob-inner {
  animation: blob-speaking 0.8s ease-in-out infinite;
  background: radial-gradient(circle at 30% 30%, #e8f5e9 0%, #c8e6c9 50%, #a5d6a7 100%);
  box-shadow:
    0 0 80px rgba(76, 175, 80, 0.5),
    0 0 120px rgba(76, 175, 80, 0.3),
    inset 0 0 30px rgba(255, 255, 255, 0.5);
}

.voice-blob-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 2px solid rgba(86, 22, 234, 0.2);
  pointer-events: none;
}

.voice-blob-ring-1 {
  width: 200px;
  height: 200px;
  animation: ring-pulse 2s ease-out infinite;
}

.voice-blob-ring-2 {
  width: 240px;
  height: 240px;
  animation: ring-pulse 2s ease-out infinite 0.4s;
}

.voice-blob-ring-3 {
  width: 280px;
  height: 280px;
  animation: ring-pulse 2s ease-out infinite 0.8s;
}

.voice-blob-listening .voice-blob-ring {
  border-color: rgba(86, 22, 234, 0.4);
}

.voice-blob-thinking .voice-blob-ring {
  border-color: rgba(255, 193, 7, 0.4);
}

.voice-blob-speaking .voice-blob-ring {
  border-color: rgba(76, 175, 80, 0.4);
}

@keyframes blob-morph {
  0%, 100% { border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%; transform: translate(-50%, -50%) rotate(0deg); }
  25% { border-radius: 70% 30% 50% 50% / 30% 30% 70% 70%; }
  50% { border-radius: 50% 50% 30% 70% / 55% 45% 55% 45%; transform: translate(-50%, -50%) rotate(180deg); }
  75% { border-radius: 30% 70% 70% 30% / 70% 70% 30% 30%; }
}

@keyframes blob-initializing {
  0%, 100% {
    transform: translate(-50%, -50%) scale(0.95);
    opacity: 0.7;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.05);
    opacity: 1;
  }
}

@keyframes ring-pulse-slow {
  0% {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0.4;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.3);
    opacity: 0;
  }
}

@keyframes blob-morph-active {
  0%, 100% {
    border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;
    transform: translate(-50%, -50%) scale(1);
  }
  25% {
    border-radius: 70% 30% 50% 50% / 30% 30% 70% 70%;
    transform: translate(-50%, -50%) scale(1.1);
  }
  50% {
    border-radius: 50% 50% 30% 70% / 55% 45% 55% 45%;
    transform: translate(-50%, -50%) scale(0.95);
  }
  75% {
    border-radius: 30% 70% 70% 30% / 70% 70% 30% 30%;
    transform: translate(-50%, -50%) scale(1.05);
  }
}

@keyframes blob-thinking {
  0%, 100% { transform: translate(-50%, -50%) scale(1); }
  50% { transform: translate(-50%, -50%) scale(1.08); }
}

@keyframes blob-speaking {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;
  }
  25% {
    transform: translate(-50%, -50%) scale(1.15);
    border-radius: 58% 42% 30% 70% / 55% 55% 45% 45%;
  }
  50% {
    transform: translate(-50%, -50%) scale(0.9);
    border-radius: 70% 30% 58% 42% / 45% 55% 45% 55%;
  }
  75% {
    transform: translate(-50%, -50%) scale(1.1);
    border-radius: 30% 70% 42% 58% / 55% 45% 55% 45%;
  }
}

@keyframes ring-pulse {
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 0.6;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0;
  }
}

.voice-status-text {
  position: relative;
  z-index: 1;
  color: #ffffff;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.voice-hint-text {
  position: relative;
  z-index: 1;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  margin-bottom: 60px;
}

.voice-controls {
  position: absolute;
  bottom: 60px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.voice-control-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.2s, background-color 0.2s, box-shadow 0.2s;
}

.voice-cancel-btn {
  width: 56px;
  height: 56px;
  background-color: #e53935;
  color: white;
  font-size: 22px;
  box-shadow: 0 4px 20px rgba(229, 57, 53, 0.4);
}

.voice-cancel-btn:hover {
  background-color: #c62828;
  transform: scale(1.05);
  box-shadow: 0 6px 25px rgba(229, 57, 53, 0.5);
}

.voice-cancel-btn:active {
  transform: scale(0.95);
}

.voice-interrupt-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  color: white;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.voice-interrupt-btn:hover {
  background-color: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.voice-interrupt-btn:active {
  transform: scale(0.95);
}

/* "Talk to a human" affordance shown directly above the textarea when the
   bot has live-agent enabled and an agent is currently online. Visually
   matches the public widget so previews stay faithful. */
.chat-modal-live-actions {
  display: flex;
  justify-content: center;
  padding: 6px 10px 4px 10px;
  background-color: white;
}

.chat-modal-live-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #5616ea;
  background: #f5f1ff;
  border: 1px solid #e0d4ff;
  border-radius: 999px;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.15s ease, transform 0.1s ease, border-color 0.15s ease;
}

.chat-modal-live-action-btn:hover {
  background: #ebe1ff;
  border-color: #d2c0ff;
  transform: translateY(-1px);
}

.chat-modal-live-action-btn:active {
  transform: translateY(0);
}


.voice-interrupt-btn span {
  white-space: nowrap;
}

.voice-controls {
  display: flex;
  gap: 16px;
  align-items: center;
}

@media (max-width: 768px) {
  .voice-visualizer-container {
    width: 240px;
    height: 240px;
    margin-bottom: 30px;
  }

  .voice-blob-inner {
    width: 120px;
    height: 120px;
  }

  .voice-blob-ring-1 { width: 170px; height: 170px; }
  .voice-blob-ring-2 { width: 200px; height: 200px; }
  .voice-blob-ring-3 { width: 230px; height: 230px; }

  .voice-status-text {
    font-size: 20px;
  }

  .voice-controls {
    bottom: 40px;
  }

  .voice-stop-btn {
    width: 44px;
    height: 44px;
  }

  .voice-cancel-btn {
    width: 52px;
    height: 52px;
  }

  .voice-interrupt-btn {
    padding: 10px 16px;
    font-size: 13px;
  }
}

/* Pre-chat form styles */
.pre-chat-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 30px;
  height: 100%;
  text-align: center;
}

.pre-chat-form-header {
  margin-bottom: 30px;
}

.pre-chat-form-icon {
  font-size: 48px;
  color: #5616ea;
  margin-bottom: 16px;
}

.pre-chat-form-header h3 {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.pre-chat-form-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.pre-chat-form-header .pre-chat-form-note {
  margin-top: 8px;
  font-size: 13px;
  color: #555;
}

.pre-chat-form-fields {
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.pre-chat-field {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.pre-chat-field label {
  font-size: 13px;
  font-weight: 600;
  color: #444;
  margin-bottom: 6px;
  text-transform: capitalize;
}

.pre-chat-field input {
  padding: 12px 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 15px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  outline: none;
}

.pre-chat-field input:focus {
  border-color: #5616ea;
  box-shadow: 0 0 0 3px rgba(86, 22, 234, 0.1);
}

.pre-chat-field input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.pre-chat-field input::placeholder {
  color: #999;
}

.pre-chat-submit-btn {
  background-color: #5616ea;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 160px;
}

.pre-chat-submit-btn:hover:not(:disabled) {
  background-color: #4512c4;
  transform: translateY(-1px);
}

.pre-chat-submit-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 600px) {
  .pre-chat-form-container {
    padding: 30px 20px;
  }

  .pre-chat-form-icon {
    font-size: 40px;
  }

  .pre-chat-form-header h3 {
    font-size: 20px;
  }

  .pre-chat-form-fields {
    max-width: 100%;
  }
}

/* ── Agent activity timeline (SSE \`status\` events, Perplexity-style) ──
   Rendered as a real bot message (avatar + bubble) from the first frame
   after send — there is no dots loader anymore. Rules that make it feel
   engineered, not animated-at-random:
   - every row has a FIXED height and never wraps -> the block only ever
     grows by exact row increments, and the bottom spacer absorbs each
     increment in the same layout pass -> the chat NEVER jumps;
   - completed rows check off in place (icon cross-fades dot -> check);
   - only the last row pulses + shimmers — the timeline always looks alive;
   - on answer start the rows roll away upward, staggered top-first, and
     the bubble folds shut underneath the incoming answer. */
.chat-status-message {
  animation: chat-status-bubble-in 0.28s cubic-bezier(0.25, 0.9, 0.3, 1);
}

@keyframes chat-status-bubble-in {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: none; }
}

/* NOTE: the .chat-status-message block itself NEVER animates on collapse —
   it contains the avatar, and the avatar must not move or fade a single
   pixel during the hand-off to the answer. Only the inner bubble folds. */

.chat-status-timeline {
  display: flex;
  flex-direction: column;
  background: #fff;              /* the bot bubble look — seamless hand-off */
  border-radius: 8px;
  padding: 9px 12px;
  max-width: 70%;
  min-width: 230px;
  max-height: 280px;
  overflow: hidden;
}

/* Answer hand-off: the bubble fades out as ONE piece (calm, no per-row
   choreography), then folds shut while already invisible — so the visible
   part of the exit is a pure fade, and the height change happens off-eye.
   Total ends at ~440ms; collapseStatus's timer (460ms) swaps in the answer
   right after. */
.chat-status-timeline.collapsing {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
  transition: opacity 0.24s ease,
              max-height 0.2s ease 0.24s, padding 0.2s ease 0.24s;
}

.chat-status-step {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 26px;                  /* FIXED row height — the no-jump contract */
  flex-shrink: 0;
  font-size: 13px;
  color: #6b6b76;
  white-space: nowrap;           /* rows never wrap, details ellipsize */
  overflow: hidden;
  /* Entry animates OPACITY/TRANSFORM ONLY — never height. An animated height
     desynchronizes the spacer (it measures 0px at insert, the row then grows
     unwatched, the next recalc snaps back) and the scrollbar thumb dances
     through every status update. */
  animation: chat-status-row-in 0.2s ease;
}

@keyframes chat-status-row-in {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: none; }
}

.chat-status-icon {
  width: 15px;
  height: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #5616ea;
  flex-shrink: 0;
}

.chat-status-icon svg {
  animation: chat-status-check-pop 0.22s cubic-bezier(0.3, 1.4, 0.5, 1);
}

@keyframes chat-status-check-pop {
  from { transform: scale(0.4); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

.chat-status-step.done {
  color: #9a9aa5;
}

.chat-status-step.done .chat-status-icon {
  opacity: 0.6;
}

/* Newest step: soft left-to-right shimmer across the label text. */
.chat-status-step.active .chat-status-label {
  background: linear-gradient(90deg, #55555e 0%, #55555e 40%, #b9a8f7 50%, #55555e 60%, #55555e 100%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: chat-status-shimmer 1.6s linear infinite;
}

@keyframes chat-status-shimmer {
  from { background-position: 200% 0; }
  to   { background-position: 0% 0; }
}

.chat-status-pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #5616ea;
  box-shadow: 0 0 0 0 rgba(86, 22, 234, 0.35);
  animation: chat-status-pulse 1.2s ease-in-out infinite;
}

@keyframes chat-status-pulse {
  0%   { transform: scale(0.8); box-shadow: 0 0 0 0 rgba(86, 22, 234, 0.35); }
  55%  { transform: scale(1);   box-shadow: 0 0 0 5px rgba(86, 22, 234, 0); }
  100% { transform: scale(0.8); box-shadow: 0 0 0 0 rgba(86, 22, 234, 0); }
}

/* The step's detail — the agent's composed search query, typed out live.
   Inline with its row, ellipsized: it can never change the row's height. */
.chat-status-detail {
  font-size: 12.5px;
  font-style: italic;
  color: #8a8a95;
  margin-left: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.chat-status-step.active .chat-status-detail {
  color: #75758a;
}
`, "",{"version":3,"sources":["webpack://./src/components/chatModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;;;0EAG0E;AAC1E;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ;;wEAEsE;EACtE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA,uEAAuE;AACvE;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;AACA,0EAA0E;AAC1E;EACE,YAAY;AACd;AACA;;;;8DAI8D;AAC9D;;;EAGE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;oCACoC;AACpC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;gEACgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;yCACyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,2BAA2B,SAAS,EAAE;;AAEtC;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB,aAAa,kCAAkC;AACjE;;AAEA,8DAA8D;AAC9D;;;;;;EAME,cAAc,eAAe,yCAAyC;EACtE,oBAAoB;EACpB,gBAAgB,aAAa,kCAAkC;AACjE;;AAEA,qCAAqC;AACrC;;EAEE,cAAc,eAAe,yBAAyB;EACtD,oBAAoB,SAAS,mBAAmB;AAClD;;AAEA;EACE,eAAe,cAAc,qCAAqC;AACpE;;AAEA,sCAAsC;AACtC;EACE,cAAc,eAAe,wBAAwB;AACvD;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE;IACE,YAAY;IACZ,2BAA2B;EAC7B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B,EAAE,4BAA4B;AAC3D;AACA;EACE,4BAA4B,EAAE,6BAA6B;AAC7D;AACA;EACE,8BAA8B,EAAE,+BAA+B;AACjE;AACA;EACE,+BAA+B,EAAE,gCAAgC;AACnE;;AAEA;EACE,4CAA4C,EAAE,yDAAyD;AACzG;AACA,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;;;;YAKY;AACZ;EACE,oBAAoB;AACtB;AACA;;yDAEyD;AACzD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kEAAkE;EAClE,oCAAoC;EAEpC,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB;;oCAEkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;EACzB;;EAEA;;;;6BAI2B;EAC3B;IACE,SAAS;IACT;;+CAE2C;IAC3C,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,6DAA6D;AAC7D;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;6EAE6E;AAC7E;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;6DAC6D;AAC7D;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sFAAsF;EACtF,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wCAAwC;EACxC,6DAA6D;EAC7D,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,2CAA2C,EAAE;EAChE,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAChE;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,mDAAmD;EACnD,oBAAoB;EACpB,oBAAoB;EACpB,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0EAA0E;EAC1E,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,qBAAqB,EAAE;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,qFAAqF;EACrF,gDAAgD;EAChD;;;2CAGyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,sDAAsD;EACtD,qFAAqF;EACrF;;;2CAGyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;EACE,sDAAsD;EACtD;;;2CAGyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,qFAAqF;EACrF;;;2CAGyC;AAC3C;;AAEA;EACE,kDAAkD;EAClD,qFAAqF;EACrF;;;2CAGyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW,gDAAgD,EAAE,6CAA6C,EAAE;EAC5G,MAAM,gDAAgD,EAAE;EACxD,MAAM,gDAAgD,EAAE,+CAA+C,EAAE;EACzG,MAAM,gDAAgD,EAAE;AAC1D;;AAEA;EACE;IACE,4CAA4C;IAC5C,YAAY;EACd;EACA;IACE,4CAA4C;IAC5C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,YAAY;EACd;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,yCAAyC;EAC3C;EACA;IACE,gDAAgD;IAChD,2CAA2C;EAC7C;EACA;IACE,gDAAgD;IAChD,4CAA4C;EAC9C;EACA;IACE,gDAAgD;IAChD,4CAA4C;EAC9C;AACF;;AAEA;EACE,WAAW,yCAAyC,EAAE;EACtD,MAAM,4CAA4C,EAAE;AACtD;;AAEA;EACE;IACE,yCAAyC;IACzC,gDAAgD;EAClD;EACA;IACE,4CAA4C;IAC5C,gDAAgD;EAClD;EACA;IACE,2CAA2C;IAC3C,gDAAgD;EAClD;EACA;IACE,2CAA2C;IAC3C,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,YAAY;EACd;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;yDAEyD;AACzD;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,qFAAqF;AACvF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,qBAAqB,YAAY,EAAE,aAAa,EAAE;EAClD,qBAAqB,YAAY,EAAE,aAAa,EAAE;EAClD,qBAAqB,YAAY,EAAE,aAAa,EAAE;;EAElD;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,wDAAwD;EACxD,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2DAA2D;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;;;;;;;;;4DAU4D;AAC5D;EACE,sEAAsE;AACxE;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;;AAEA;;0EAE0E;;AAE1E;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB,eAAe,4CAA4C;EAC3E,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;iBAIiB;AACjB;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV;iEAC+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY,mBAAmB,4CAA4C;EAC3E,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB,YAAY,uCAAuC;EACtE,gBAAgB;EAChB;;;mCAGiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,mEAAmE;AACnE;EACE,mGAAmG;EACnG,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,sDAAsD;AACxD;;AAEA;EACE,OAAO,qBAAqB,EAAE,2CAA2C,EAAE;EAC3E,OAAO,mBAAmB,IAAI,0CAA0C,EAAE;EAC1E,OAAO,qBAAqB,EAAE,wCAAwC,EAAE;AAC1E;;AAEA;2EAC2E;AAC3E;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".chat-modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n/* ── Embedded (inline) mode ──────────────────────────────────────────────\r\n   Renders the chat inside a page container (the Overview playground) rather\r\n   than as a fullscreen overlay: it fills its parent, drops the backdrop and\r\n   close button, and lets its inner column flex to the available height. */\r\n.chat-modal.embedded {\r\n  position: relative;\r\n  inset: auto;\r\n  top: auto;\r\n  left: auto;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: block;\r\n  z-index: auto;\r\n}\r\n.chat-modal.embedded .chat-modal-overlay {\r\n  display: none;\r\n}\r\n.chat-modal.embedded .chat-modal-close-btn {\r\n  display: none;\r\n}\r\n.chat-modal.embedded .chat-modal-content {\r\n  width: 100%;\r\n  max-width: none;\r\n  height: 100%;\r\n  /* Include the 10px padding (and 1px border) in the 100% height — without\r\n     border-box the padding is ADDED to 100%, so the chat overflows its cell\r\n     by ~20px and the playground ends up taller than the right column. */\r\n  box-sizing: border-box;\r\n  border: 1px solid #e5e7eb;\r\n  box-shadow: none;\r\n}\r\n.chat-modal.embedded .chat-parent {\r\n  max-width: none;\r\n}\r\n/* Main chat: fill the space below the header inside the flex column. */\r\n.chat-modal.embedded .chat-modal-content > .chat-parent {\r\n  height: auto;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n}\r\n/* Upgrade-locked state renders .chat-parent directly under .chat-modal. */\r\n.chat-modal.embedded > .chat-parent {\r\n  height: 100%;\r\n}\r\n/* Make the embedded chat a strict, shrinkable flex column: min-height:0 lets the\r\n   message list shrink below its content and scroll internally, and the input is\r\n   pinned (flex-shrink:0) so it stays visible at the bottom on any viewport. Without\r\n   min-height:0 the message list pushes the input out of the clipped box on short\r\n   (mobile) viewports — that was the \"no input visible\" bug. */\r\n.chat-modal.embedded .chat-parent,\r\n.chat-modal.embedded .logo-messages-container,\r\n.chat-modal.embedded .message-container {\r\n  min-height: 0;\r\n}\r\n.chat-modal.embedded .chat-input {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.chat-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 999;\r\n}\r\n\r\n.chat-modal-content {\r\n  position: relative;\r\n  z-index: 1001;\r\n  width: 95%;\r\n  max-width: 750px;\r\n  height: 80vh;\r\n  background-color: white;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);\r\n  overflow: hidden;\r\n  padding: 10px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.chat-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-shrink: 0;\r\n  padding: 2px 0px 8px 8px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.chat-modal-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  min-width: 0;\r\n}\r\n\r\n.chat-modal-header-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  min-width: 0;\r\n}\r\n\r\n.chat-modal-header-title {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #20202a;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* Subtitle under the title — mirrors the Overview \"Live chat\" subtitle\r\n   (.ov-action-sub): small, muted. */\r\n.chat-modal-header-sub {\r\n  font-size: 12px;\r\n  color: #82828e;\r\n  line-height: 1.3;\r\n}\r\n\r\n/* Purple rounded-square icon before the title — mirrors the Overview's\r\n   \".ov-action-ic\" (Live chat) style so the two read as a set. */\r\n.chat-modal-header-ic {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 8px;\r\n  background: #f3f0fc;\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Right-side header controls (Clear + close), kept together on the title\r\n   line via the header's space-between. */\r\n.chat-modal-header-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.chat-modal-clear-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 5px 11px;\r\n  font-family: inherit;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n  background: #f4f1fd;\r\n  border: 1px solid #e7defb;\r\n  border-radius: 7px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\r\n}\r\n\r\n.chat-modal-clear-btn:hover:not(:disabled) {\r\n  background: #ece5fb;\r\n  border-color: #d7c6f6;\r\n}\r\n\r\n.chat-modal-clear-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.chat-modal-clear-btn svg {\r\n  font-size: 11px;\r\n}\r\n\r\n.chat-modal-close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n  color: #888;\r\n  cursor: pointer;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n  transition: all 0.2s ease;\r\n  line-height: 1;\r\n}\r\n\r\n.chat-modal-close-btn:hover {\r\n  background: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.chat-modal-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.chat-modal-spinner {\r\n  font-size: 40px;\r\n  color: #5616ea;\r\n}\r\n\r\n.text-container {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 10px;\r\n  margin-top: 10px;\r\n  margin-right: 50px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.text-container p {\r\n  margin: 0;\r\n  line-height: 1.5;\r\n  font-size: 14px;\r\n}\r\n\r\n.word {\r\n  font-weight: bold;\r\n  margin: 0;\r\n  padding: 0;\r\n  margin-right: 1px;\r\n  font-size: 19.5px;\r\n  color: #5616ea;\r\n  line-height: 1.1;\r\n}\r\n\r\n.chat-parent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  max-width: 800px;\r\n  background-color: white;\r\n  overflow: hidden;\r\n}\r\n\r\n.chat-knowledge-banner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  background-color: #fff9e1;\r\n  border-left: 4px solid #ffc107;\r\n  border-radius: 8px;\r\n  padding: 10px 12px 12px 12px;\r\n  margin: 0 10px 12px 10px;\r\n  color: #554002;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.chat-knowledge-banner-textrow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.chat-knowledge-banner p { margin: 0; }\r\n\r\n.chat-knowledge-banner-icon {\r\n  font-size: 20px;\r\n  color: #ffc107;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.manage-knowledge-button {\r\n  background: #fff;\r\n  border: 1px solid #e4d59c;\r\n  color: #554002;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  padding: 6px 14px;\r\n  font-size: 13px;\r\n  border-radius: 6px;\r\n  box-shadow: 0 0 0 0 rgba(0,0,0,0);\r\n  transition: background-color .15s ease, transform .15s ease, box-shadow .2s ease;\r\n}\r\n\r\n.manage-knowledge-button:hover {\r\n  background: #ffeaa3;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.manage-knowledge-button:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.logo-messages-container {\r\n  position: relative;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-right: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n.message-container {\r\n  position: relative;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  margin-right: -10px;\r\n}\r\n\r\n.message {\r\n  display: flex;\r\n  flex-direction: row;\r\n  color: white;\r\n  border-radius: 10px;\r\n  padding: 10px;\r\n  padding-top: 5px;\r\n  padding-bottom: 8px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.user-message {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.bot-message {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.user-message p, .bot-message p {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.user-icon {\r\n  height: 32px;\r\n  width: 32px;\r\n  margin-left: 8px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.bot-left-icon {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 8px;\r\n  height: 40px;\r\n  width: 40px;\r\n  background-color: #5616ea;\r\n  border-radius: 150px;\r\n  flex-direction: column;\r\n}\r\n\r\n.bot-left-icon-text {\r\n  margin-bottom: 6px;\r\n  margin-right: 0.5px;\r\n}\r\n\r\n.scf-logo-top {\r\n  height: 65px;\r\n}\r\n\r\n.bot-chat-text,\r\n.user-chat-text {\r\n  max-width: 70%;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  background: #fff;\r\n  color: #333;\r\n  padding: 7px;\r\n}\r\n\r\n.bot-chat-text a {\r\n  color: #5616ea;\r\n  font-weight: 500;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* ------------- paragraphs ------------ */\r\n.bot-chat-text p {\r\n  margin: 0 0 .9em;            /* .6em gap after each paragraph */\r\n}\r\n\r\n/* ------------- headings: match paragraph size ------------ */\r\n.bot-chat-text h1,\r\n.bot-chat-text h2,\r\n.bot-chat-text h3,\r\n.bot-chat-text h4,\r\n.bot-chat-text h5,\r\n.bot-chat-text h6 {\r\n  font-size: 1em;              /* same as paragraph (container's 16px) */\r\n  line-height: inherit;\r\n  margin: 0 0 .9em;            /* align spacing with paragraphs */\r\n}\r\n\r\n/* ------------- lists ------------ */\r\n.bot-chat-text ul,\r\n.bot-chat-text ol {\r\n  margin: .9em 0;              /* same top-/bottom gap */\r\n  padding-left: 1.25em;        /* indent bullets */\r\n}\r\n\r\n.bot-chat-text li {\r\n  margin: .25em 0;             /* tighten bullet-to-bullet spacing */\r\n}\r\n\r\n/* ------------- tables ------------ */\r\n.bot-chat-text table {\r\n  margin: .9em 0;              /* no more 15px canyon */\r\n}\r\n\r\n.bot-chat-text > :first-child {\r\n  margin-top: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.bot-chat-text > :last-child {\r\n  margin-bottom: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.user-chat-text {\r\n  background-color: #f2f2f2;\r\n  border: none;\r\n  text-align: left;\r\n  color: #000000;\r\n  padding: 7px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.send-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  fill: currentColor;\r\n  display: block;\r\n}\r\n\r\n.chat-input {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 6px;\r\n  border-top: 1px solid #f1f1f1;\r\n  padding: 10px;\r\n  background-color: #fafafa;\r\n}\r\n\r\n.chat-input textarea {\r\n  flex: 1;\r\n  padding: 6px 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  font-size: 16px;\r\n  resize: none;\r\n  line-height: 1.4;\r\n  max-height: 140px;\r\n  overflow-y: hidden;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.chat-input textarea.has-overflow {\r\n  overflow-y: auto;\r\n}\r\n\r\n.loading-dots {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  height: 40px;\r\n  margin-top: 10px;\r\n  margin-bottom: 5px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.loading-dots div {\r\n  width: 8px;\r\n  height: 8px;\r\n  margin: 0 4px;\r\n  border-radius: 50%;\r\n  background-color: #5616ea;\r\n  animation: loading-bounce 0.6s infinite alternate;\r\n}\r\n\r\n@keyframes loading-bounce {\r\n  to {\r\n    opacity: 0.3;\r\n    transform: translateY(-8px);\r\n  }\r\n}\r\n\r\n.loading-dots div:nth-child(2) {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.loading-dots div:nth-child(3) {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n.input-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 15px;\r\n  height: 34px;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  background-color: #5616ea;\r\n  transition: background-color 0.4s ease, transform 0.2s ease;\r\n}\r\n\r\n.input-button:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1.5px);\r\n}\r\n\r\n/* table styles */\r\n.message table {\r\n  border-collapse: separate;\r\n  border-spacing: 0px;\r\n  margin-top: 15px;\r\n  margin-bottom: 15px;\r\n  width: 100%;\r\n  overflow: auto;\r\n}\r\n\r\n.message th, .message td {\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n  padding: .35rem .50rem;\r\n  text-align: left;\r\n  font-size: 14px;\r\n}\r\n\r\n.message th {\r\n  color: #000000;\r\n  background-color: rgba(0, 0, 0, 0.06);\r\n  border-right: 0;\r\n  padding: .5rem .50rem;\r\n}\r\n\r\n.message th:last-child {\r\n  border-right: 1px solid rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.message th {\r\n  border-bottom: none;\r\n}\r\n\r\n.message td {\r\n  border-bottom: 0px solid rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.message td {\r\n  border-right: 0px solid rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.message td:last-child {\r\n  border-right: 1px solid rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.message tr:first-child th:first-child {\r\n  border-top-left-radius: 8px; /* Rounded top left corner */\r\n}\r\n.message tr:first-child th:last-child {\r\n  border-top-right-radius: 8px; /* Rounded top right corner */\r\n}\r\n.message tr:last-child td:first-child {\r\n  border-bottom-left-radius: 8px; /* Rounded bottom left corner */\r\n}\r\n.message tr:last-child td:last-child {\r\n  border-bottom-right-radius: 8px; /* Rounded bottom right corner */\r\n}\r\n\r\n.message tr:last-child td {\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08); /* Adds bottom border back on all cells of the last row */\r\n}\r\n/*Table style ending*/\r\n\r\n.upgrade-locked-container {\r\n  position: relative;\r\n  z-index: 1001;\r\n  width: 95%;\r\n  max-width: 450px;\r\n  max-height: 150px;\r\n  background-color: white;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);\r\n  padding: 10px;\r\n  gap: 10px;\r\n}\r\n\r\n.upgrade-button {\r\n  background-color: #5616ea;\r\n  color: white;\r\n  padding: 10px 24px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  transition: 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.upgrade-button:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* ── Upgrade-locked overlay ───────────────────────────────────────────────\r\n   At the message limit we keep the full chat (same structure + size) but lay\r\n   one frosted scrim over the WHOLE content — header included — and float a\r\n   premium upgrade card on it. The only live control is a clean, background-less\r\n   close button (Test Agent modal only; the embedded Overview playground has no\r\n   close). */\r\n.chat-modal-content.is-locked > .chat-parent {\r\n  pointer-events: none;\r\n}\r\n/* The header is blurred behind the frost; hide its live buttons (Clear + the\r\n   built-in close) so they don't show as a smudge behind the single floating\r\n   close button below. The title stays, softly blurred. */\r\n.chat-modal-content.is-locked .chat-modal-header-actions {\r\n  visibility: hidden;\r\n}\r\n\r\n.chat-locked-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 5;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  /* Faint brand-tinted frost so the chat reads as \"behind glass\". */\r\n  background: rgba(247, 245, 255, 0.6);\r\n  -webkit-backdrop-filter: blur(5px) saturate(115%);\r\n  backdrop-filter: blur(5px) saturate(115%);\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Floating close — sits on the frost, no background, just the glyph. */\r\n.chat-locked-close {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 14px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 34px;\r\n  height: 34px;\r\n  padding: 0;\r\n  border: none;\r\n  background: transparent;\r\n  color: #6b6b78;\r\n  font-size: 18px;\r\n  line-height: 1;\r\n  border-radius: 9px;\r\n  cursor: pointer;\r\n  transition: color 0.15s ease, background 0.15s ease;\r\n}\r\n.chat-locked-close:hover {\r\n  color: #20202a;\r\n  background: rgba(86, 22, 234, 0.08);\r\n}\r\n\r\n.chat-locked-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  max-width: 360px;\r\n  padding: 34px 30px;\r\n  background: #ffffff;\r\n  border: 1px solid #efeafd;\r\n  border-radius: 18px;\r\n  box-shadow:\r\n    0 24px 50px -18px rgba(86, 22, 234, 0.30),\r\n    0 2px 6px rgba(20, 10, 50, 0.05);\r\n}\r\n\r\n.chat-locked-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #6a2bff 0%, #5616ea 100%);\r\n  color: #ffffff;\r\n  font-size: 22px;\r\n  box-shadow: 0 10px 22px -6px rgba(86, 22, 234, 0.55);\r\n}\r\n\r\n.chat-locked-title {\r\n  margin: 20px 0 0;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  letter-spacing: -0.01em;\r\n  color: #1d1b2e;\r\n}\r\n\r\n.chat-locked-sub {\r\n  margin: 8px 0 0;\r\n  max-width: 280px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: #6b6b78;\r\n}\r\n\r\n.chat-locked-btn {\r\n  margin-top: 22px;\r\n  padding: 11px 30px;\r\n  border-radius: 10px;\r\n  font-size: 15px;\r\n  box-shadow: 0 10px 22px -8px rgba(86, 22, 234, 0.6);\r\n}\r\n.chat-locked-btn:hover {\r\n  box-shadow: 0 12px 26px -8px rgba(86, 22, 234, 0.7);\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .chat-modal-content {\r\n    margin: 10px;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .chat-parent {\r\n    display: flex;\r\n    height: 90vh;\r\n    justify-content: center;\r\n  }\r\n\r\n  /* Embedded playground (Overview): the fullscreen-modal mobile sizing above\r\n     breaks it — the content margin pushes the input below its clipped parent,\r\n     and the fixed chat-parent/message-container heights fight the flex layout.\r\n     Neutralise them so the embedded chat fills its cell and the input stays\r\n     visible at the bottom. */\r\n  .chat-modal.embedded .chat-modal-content {\r\n    margin: 0;\r\n    /* Restore the side gutter the fullscreen-modal mobile rule strips\r\n       (padding-left/right:0), so the header's Clear button and the messages\r\n       keep space from the playground border. */\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n  }\r\n  .chat-modal.embedded .chat-parent {\r\n    height: auto;\r\n    justify-content: flex-start;\r\n  }\r\n  .chat-modal.embedded .message-container {\r\n    height: auto;\r\n  }\r\n\r\n  .user-message {\r\n    max-width: 92%;\r\n  }\r\n\r\n  .logo-messages-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n\r\n  .text-container {\r\n    margin-right: 0px;\r\n  }\r\n\r\n  .chat-input {\r\n    width: 95%;\r\n  }\r\n\r\n  .bot-icon {\r\n    height: 24px;\r\n    min-width: 24px;\r\n  }\r\n\r\n  .scf-icon {\r\n    width: 30px;\r\n    height: 30px;\r\n    margin-top: -2px;\r\n  }\r\n\r\n  .loader {\r\n    margin-left: 10px;\r\n  }\r\n\r\n  .message-container {\r\n    height: 83%;\r\n  }\r\n}\r\n\r\n/* allow children (icon, bubble, CTA) to wrap to a new line */\r\n.message {\r\n  align-items: flex-start;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* In-chat product gallery: breaks to its own full-width line under the reply\r\n   text (the bot message row is flex-wrap). box-sizing + padding-left indents the\r\n   cards to line up past the 40px agent avatar without overflowing the row. */\r\n.ub-pc-inline {\r\n  flex-basis: 100%;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding-left: 48px;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* When the gallery sits between the reply and the Q&A helper, keep the helper's\r\n   indent (its usual adjacency selector no longer matches). */\r\n.ub-pc-inline + .qa-cta {\r\n  margin-left: 48px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .ub-pc-inline {\r\n    padding-left: 8px;\r\n  }\r\n}\r\n\r\n.qa-cta {\r\n  flex-basis: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  margin-top: 0px;\r\n  gap: 3px;\r\n  margin-left: 0;\r\n  padding-top: 5px;\r\n}\r\n\r\n.qa-span-button-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.qa-cta span{\r\n  color: #373737;\r\n  font-size: 10px;\r\n}\r\n\r\n.message .scf-icon-container + .bot-chat-text + .qa-cta {\r\n  margin-left: 48px;\r\n}\r\n\r\n.qa-cta .add-faq-button {\r\n  background: transparent;\r\n  border: 1px solid #e0e0e0;\r\n  padding: 4px 10px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  color: #5616ea;\r\n}\r\n\r\n.qa-cta .add-faq-button:hover {\r\n  background: #f4f4f4ff;\r\n}\r\n\r\n.qa-lighbulb-icon {\r\n  margin-right: 2px;\r\n  font-size: 12px;\r\n}\r\n\r\n.message-usage-row {\r\n  padding: 0 12px 0px 12px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.message-usage-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  grid-template-rows: auto auto;\r\n  column-gap: 20px;\r\n  row-gap: 2px;\r\n  align-items: center;\r\n  width: 40%;\r\n}\r\n\r\n.message-usage-text {\r\n  font-size: 10px;\r\n  color: #555;\r\n  line-height: 1.2;\r\n}\r\n\r\n.message-plan-name {\r\n  font-size: 10px;\r\n  color: #555;\r\n  line-height: 1.2;\r\n  text-align: left;\r\n  justify-self: start;\r\n}\r\n\r\n.message-usage-text--danger {\r\n  color: #d53535;\r\n  font-weight: 600;\r\n}\r\n\r\n.message-usage-bar {\r\n  height: 3px;\r\n  background-color: #e6e6e6;\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n  width: 180px;\r\n  min-width: 120px;\r\n}\r\n\r\n.message-usage-fill {\r\n  height: 100%;\r\n  background-color: #5616ea;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.message-usage-cta {\r\n  padding: 5px 12px;\r\n  font-size: 11px;\r\n  line-height: 1;\r\n  border-radius: 8px;\r\n  border: 1px solid #e0e0e0;\r\n  background: #ffffff;\r\n  color: #333;\r\n  cursor: pointer;\r\n  transition: transform 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;\r\n  justify-self: start;\r\n}\r\n\r\n.message-usage-cta:hover {\r\n  background: #f6f6f6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.message-usage-cta:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.message-usage-cta--attention {\r\n  border-color: #d53535;\r\n  color: #d53535;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .message-usage-row {\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n  }\r\n  .message-usage-grid {\r\n    column-gap: 8px;\r\n    width: 70%;\r\n  }\r\n  .message-usage-bar {\r\n    width: 140px;\r\n    min-width: 100px;\r\n  }\r\n  .message-usage-cta {\r\n    padding: 6px 10px;\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n/* ——— busy/disabled visuals ——— */\r\n.input-button[disabled] {\r\n  opacity: 0.5 !important;\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n/* Scroll-to-bottom floating button */\r\n.scroll-to-bottom-btn {\r\n  position: absolute;\r\n  bottom: 8px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  border: 1px solid #e0e0e0;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  transition: background-color 0.15s ease, box-shadow 0.2s ease;\r\n  z-index: 5;\r\n  animation: scroll-btn-fade-in 0.2s ease both;\r\n}\r\n\r\n.scroll-to-bottom-btn:hover {\r\n  background: #f0f0f0;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.scroll-to-bottom-btn:active {\r\n  background: #e8e8e8;\r\n}\r\n\r\n@keyframes scroll-btn-fade-in {\r\n  from { opacity: 0; transform: translateX(-50%) translateY(6px); }\r\n  to   { opacity: 1; transform: translateX(-50%) translateY(0); }\r\n}\r\n\r\n.chat-input textarea:disabled {\r\n  background: #f5f5f5 !important;\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n.predefined-question.is-disabled {\r\n  opacity: 0.5 !important;\r\n  pointer-events: none !important;\r\n}\r\n\r\n.voice-button {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 34px;\r\n  height: 34px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: linear-gradient(135deg, #f8f4ff 0%, #efe8ff 100%);\r\n  color: #5616ea;\r\n  cursor: pointer;\r\n  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;\r\n  flex-shrink: 0;\r\n  box-shadow: 0 1px 3px rgba(86, 22, 234, 0.1);\r\n}\r\n\r\n.voice-tooltip {\r\n  position: absolute;\r\n  bottom: calc(100% + 8px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: linear-gradient(135deg, #5616ea 0%, #7c3aed 100%);\r\n  color: white;\r\n  padding: 6px 12px;\r\n  border-radius: 8px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 0.2s ease, visibility 0.2s ease;\r\n  transition-delay: 0s;\r\n  pointer-events: none;\r\n  box-shadow: 0 4px 12px rgba(86, 22, 234, 0.3);\r\n  z-index: 100;\r\n}\r\n\r\n.voice-tooltip::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border: 6px solid transparent;\r\n  border-top-color: #7c3aed;\r\n}\r\n\r\n.voice-button:hover .voice-tooltip {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  transition-delay: 0.3s;\r\n}\r\n\r\n.voice-button.voice-active .voice-tooltip {\r\n  display: none;\r\n}\r\n\r\n.voice-button:hover:not([disabled]) {\r\n  background: linear-gradient(135deg, #f0e8ff 0%, #e4d8ff 100%);\r\n  transform: translateY(-1.5px);\r\n  box-shadow: 0 3px 8px rgba(86, 22, 234, 0.15);\r\n}\r\n\r\n.voice-button:active:not([disabled]) {\r\n  transform: translateY(0);\r\n}\r\n\r\n.voice-button[disabled] {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.voice-button.voice-active {\r\n  background: linear-gradient(135deg, #5616ea 0%, #7c3aed 100%);\r\n  color: white;\r\n  box-shadow: 0 2px 8px rgba(86, 22, 234, 0.3);\r\n}\r\n\r\n.voice-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 10;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.voice-overlay-bg {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(180deg, #0a0a0f 0%, #12121a 50%, #0a0a0f 100%);\r\n  z-index: 0;\r\n}\r\n\r\n.voice-status-dot {\r\n  position: absolute;\r\n  top: 40px;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background-color: #5616ea;\r\n  animation: status-dot-pulse 2s ease-in-out infinite;\r\n  z-index: 1;\r\n}\r\n\r\n@keyframes status-dot-pulse {\r\n  0%, 100% { opacity: 0.4; transform: scale(1); }\r\n  50% { opacity: 1; transform: scale(1.2); }\r\n}\r\n\r\n.voice-initializing-spinner {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 120px;\r\n  height: 120px;\r\n  margin-bottom: 40px;\r\n  font-size: 48px;\r\n  color: #5616ea;\r\n}\r\n\r\n.voice-visualizer-container {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: 280px;\r\n  height: 280px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.voice-blob {\r\n  position: relative;\r\n  width: 180px;\r\n  height: 180px;\r\n  transition: transform 0.1s ease-out;\r\n}\r\n\r\n.voice-blob-inner {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 140px;\r\n  height: 140px;\r\n  background: radial-gradient(circle at 30% 30%, #ffffff 0%, #f0f0f0 50%, #e0e0e0 100%);\r\n  border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\r\n  box-shadow:\r\n    0 0 60px rgba(86, 22, 234, 0.3),\r\n    0 0 100px rgba(86, 22, 234, 0.2),\r\n    inset 0 0 30px rgba(255, 255, 255, 0.5);\r\n  animation: blob-morph 4s ease-in-out infinite;\r\n}\r\n\r\n.voice-blob-initializing .voice-blob-inner {\r\n  animation: blob-initializing 1.2s ease-in-out infinite;\r\n  background: radial-gradient(circle at 30% 30%, #f3e8ff 0%, #e9d5ff 50%, #ddd6fe 100%);\r\n  box-shadow:\r\n    0 0 60px rgba(86, 22, 234, 0.4),\r\n    0 0 100px rgba(86, 22, 234, 0.2),\r\n    inset 0 0 30px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.voice-blob-initializing .voice-blob-ring {\r\n  border-color: rgba(86, 22, 234, 0.3);\r\n  animation: ring-pulse-slow 2.5s ease-out infinite;\r\n}\r\n\r\n.voice-blob-listening .voice-blob-inner {\r\n  animation: blob-morph-active 1.5s ease-in-out infinite;\r\n  box-shadow:\r\n    0 0 80px rgba(86, 22, 234, 0.5),\r\n    0 0 120px rgba(86, 22, 234, 0.3),\r\n    inset 0 0 30px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.voice-blob-thinking .voice-blob-inner {\r\n  animation: blob-thinking 1s ease-in-out infinite;\r\n  background: radial-gradient(circle at 30% 30%, #fff8e1 0%, #ffecb3 50%, #ffe082 100%);\r\n  box-shadow:\r\n    0 0 80px rgba(255, 193, 7, 0.5),\r\n    0 0 120px rgba(255, 193, 7, 0.3),\r\n    inset 0 0 30px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.voice-blob-speaking .voice-blob-inner {\r\n  animation: blob-speaking 0.8s ease-in-out infinite;\r\n  background: radial-gradient(circle at 30% 30%, #e8f5e9 0%, #c8e6c9 50%, #a5d6a7 100%);\r\n  box-shadow:\r\n    0 0 80px rgba(76, 175, 80, 0.5),\r\n    0 0 120px rgba(76, 175, 80, 0.3),\r\n    inset 0 0 30px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.voice-blob-ring {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  border-radius: 50%;\r\n  border: 2px solid rgba(86, 22, 234, 0.2);\r\n  pointer-events: none;\r\n}\r\n\r\n.voice-blob-ring-1 {\r\n  width: 200px;\r\n  height: 200px;\r\n  animation: ring-pulse 2s ease-out infinite;\r\n}\r\n\r\n.voice-blob-ring-2 {\r\n  width: 240px;\r\n  height: 240px;\r\n  animation: ring-pulse 2s ease-out infinite 0.4s;\r\n}\r\n\r\n.voice-blob-ring-3 {\r\n  width: 280px;\r\n  height: 280px;\r\n  animation: ring-pulse 2s ease-out infinite 0.8s;\r\n}\r\n\r\n.voice-blob-listening .voice-blob-ring {\r\n  border-color: rgba(86, 22, 234, 0.4);\r\n}\r\n\r\n.voice-blob-thinking .voice-blob-ring {\r\n  border-color: rgba(255, 193, 7, 0.4);\r\n}\r\n\r\n.voice-blob-speaking .voice-blob-ring {\r\n  border-color: rgba(76, 175, 80, 0.4);\r\n}\r\n\r\n@keyframes blob-morph {\r\n  0%, 100% { border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%; transform: translate(-50%, -50%) rotate(0deg); }\r\n  25% { border-radius: 70% 30% 50% 50% / 30% 30% 70% 70%; }\r\n  50% { border-radius: 50% 50% 30% 70% / 55% 45% 55% 45%; transform: translate(-50%, -50%) rotate(180deg); }\r\n  75% { border-radius: 30% 70% 70% 30% / 70% 70% 30% 30%; }\r\n}\r\n\r\n@keyframes blob-initializing {\r\n  0%, 100% {\r\n    transform: translate(-50%, -50%) scale(0.95);\r\n    opacity: 0.7;\r\n  }\r\n  50% {\r\n    transform: translate(-50%, -50%) scale(1.05);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes ring-pulse-slow {\r\n  0% {\r\n    transform: translate(-50%, -50%) scale(0.9);\r\n    opacity: 0.4;\r\n  }\r\n  100% {\r\n    transform: translate(-50%, -50%) scale(1.3);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes blob-morph-active {\r\n  0%, 100% {\r\n    border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\r\n    transform: translate(-50%, -50%) scale(1);\r\n  }\r\n  25% {\r\n    border-radius: 70% 30% 50% 50% / 30% 30% 70% 70%;\r\n    transform: translate(-50%, -50%) scale(1.1);\r\n  }\r\n  50% {\r\n    border-radius: 50% 50% 30% 70% / 55% 45% 55% 45%;\r\n    transform: translate(-50%, -50%) scale(0.95);\r\n  }\r\n  75% {\r\n    border-radius: 30% 70% 70% 30% / 70% 70% 30% 30%;\r\n    transform: translate(-50%, -50%) scale(1.05);\r\n  }\r\n}\r\n\r\n@keyframes blob-thinking {\r\n  0%, 100% { transform: translate(-50%, -50%) scale(1); }\r\n  50% { transform: translate(-50%, -50%) scale(1.08); }\r\n}\r\n\r\n@keyframes blob-speaking {\r\n  0%, 100% {\r\n    transform: translate(-50%, -50%) scale(1);\r\n    border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\r\n  }\r\n  25% {\r\n    transform: translate(-50%, -50%) scale(1.15);\r\n    border-radius: 58% 42% 30% 70% / 55% 55% 45% 45%;\r\n  }\r\n  50% {\r\n    transform: translate(-50%, -50%) scale(0.9);\r\n    border-radius: 70% 30% 58% 42% / 45% 55% 45% 55%;\r\n  }\r\n  75% {\r\n    transform: translate(-50%, -50%) scale(1.1);\r\n    border-radius: 30% 70% 42% 58% / 55% 45% 55% 45%;\r\n  }\r\n}\r\n\r\n@keyframes ring-pulse {\r\n  0% {\r\n    transform: translate(-50%, -50%) scale(0.8);\r\n    opacity: 0.6;\r\n  }\r\n  100% {\r\n    transform: translate(-50%, -50%) scale(1.2);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.voice-status-text {\r\n  position: relative;\r\n  z-index: 1;\r\n  color: #ffffff;\r\n  font-size: 24px;\r\n  font-weight: 500;\r\n  letter-spacing: 0.5px;\r\n  margin-bottom: 8px;\r\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.voice-hint-text {\r\n  position: relative;\r\n  z-index: 1;\r\n  color: rgba(255, 255, 255, 0.5);\r\n  font-size: 14px;\r\n  margin-bottom: 60px;\r\n}\r\n\r\n.voice-controls {\r\n  position: absolute;\r\n  bottom: 60px;\r\n  left: 0;\r\n  right: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1;\r\n}\r\n\r\n.voice-control-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  transition: transform 0.2s, background-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.voice-cancel-btn {\r\n  width: 56px;\r\n  height: 56px;\r\n  background-color: #e53935;\r\n  color: white;\r\n  font-size: 22px;\r\n  box-shadow: 0 4px 20px rgba(229, 57, 53, 0.4);\r\n}\r\n\r\n.voice-cancel-btn:hover {\r\n  background-color: #c62828;\r\n  transform: scale(1.05);\r\n  box-shadow: 0 6px 25px rgba(229, 57, 53, 0.5);\r\n}\r\n\r\n.voice-cancel-btn:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.voice-interrupt-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 12px 20px;\r\n  border-radius: 30px;\r\n  background-color: rgba(255, 255, 255, 0.15);\r\n  backdrop-filter: blur(10px);\r\n  color: white;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.voice-interrupt-btn:hover {\r\n  background-color: rgba(255, 255, 255, 0.25);\r\n  transform: scale(1.05);\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.voice-interrupt-btn:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n/* \"Talk to a human\" affordance shown directly above the textarea when the\r\n   bot has live-agent enabled and an agent is currently online. Visually\r\n   matches the public widget so previews stay faithful. */\r\n.chat-modal-live-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 6px 10px 4px 10px;\r\n  background-color: white;\r\n}\r\n\r\n.chat-modal-live-action-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 7px 16px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n  background: #f5f1ff;\r\n  border: 1px solid #e0d4ff;\r\n  border-radius: 999px;\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  transition: background-color 0.15s ease, transform 0.1s ease, border-color 0.15s ease;\r\n}\r\n\r\n.chat-modal-live-action-btn:hover {\r\n  background: #ebe1ff;\r\n  border-color: #d2c0ff;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.chat-modal-live-action-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n\r\n.voice-interrupt-btn span {\r\n  white-space: nowrap;\r\n}\r\n\r\n.voice-controls {\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: center;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .voice-visualizer-container {\r\n    width: 240px;\r\n    height: 240px;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .voice-blob-inner {\r\n    width: 120px;\r\n    height: 120px;\r\n  }\r\n\r\n  .voice-blob-ring-1 { width: 170px; height: 170px; }\r\n  .voice-blob-ring-2 { width: 200px; height: 200px; }\r\n  .voice-blob-ring-3 { width: 230px; height: 230px; }\r\n\r\n  .voice-status-text {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .voice-controls {\r\n    bottom: 40px;\r\n  }\r\n\r\n  .voice-stop-btn {\r\n    width: 44px;\r\n    height: 44px;\r\n  }\r\n\r\n  .voice-cancel-btn {\r\n    width: 52px;\r\n    height: 52px;\r\n  }\r\n\r\n  .voice-interrupt-btn {\r\n    padding: 10px 16px;\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n/* Pre-chat form styles */\r\n.pre-chat-form-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px 30px;\r\n  height: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.pre-chat-form-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.pre-chat-form-icon {\r\n  font-size: 48px;\r\n  color: #5616ea;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.pre-chat-form-header h3 {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin: 0 0 8px 0;\r\n}\r\n\r\n.pre-chat-form-header p {\r\n  font-size: 14px;\r\n  color: #666;\r\n  margin: 0;\r\n}\r\n\r\n.pre-chat-form-header .pre-chat-form-note {\r\n  margin-top: 8px;\r\n  font-size: 13px;\r\n  color: #555;\r\n}\r\n\r\n.pre-chat-form-fields {\r\n  width: 100%;\r\n  max-width: 350px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.pre-chat-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: left;\r\n}\r\n\r\n.pre-chat-field label {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #444;\r\n  margin-bottom: 6px;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.pre-chat-field input {\r\n  padding: 12px 14px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 15px;\r\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\r\n  outline: none;\r\n}\r\n\r\n.pre-chat-field input:focus {\r\n  border-color: #5616ea;\r\n  box-shadow: 0 0 0 3px rgba(86, 22, 234, 0.1);\r\n}\r\n\r\n.pre-chat-field input:disabled {\r\n  background-color: #f5f5f5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.pre-chat-field input::placeholder {\r\n  color: #999;\r\n}\r\n\r\n.pre-chat-submit-btn {\r\n  background-color: #5616ea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 14px 32px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, transform 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  min-width: 160px;\r\n}\r\n\r\n.pre-chat-submit-btn:hover:not(:disabled) {\r\n  background-color: #4512c4;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.pre-chat-submit-btn:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .pre-chat-form-container {\r\n    padding: 30px 20px;\r\n  }\r\n\r\n  .pre-chat-form-icon {\r\n    font-size: 40px;\r\n  }\r\n\r\n  .pre-chat-form-header h3 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .pre-chat-form-fields {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n/* ── Agent activity timeline (SSE `status` events, Perplexity-style) ──\r\n   Rendered as a real bot message (avatar + bubble) from the first frame\r\n   after send — there is no dots loader anymore. Rules that make it feel\r\n   engineered, not animated-at-random:\r\n   - every row has a FIXED height and never wraps -> the block only ever\r\n     grows by exact row increments, and the bottom spacer absorbs each\r\n     increment in the same layout pass -> the chat NEVER jumps;\r\n   - completed rows check off in place (icon cross-fades dot -> check);\r\n   - only the last row pulses + shimmers — the timeline always looks alive;\r\n   - on answer start the rows roll away upward, staggered top-first, and\r\n     the bubble folds shut underneath the incoming answer. */\r\n.chat-status-message {\r\n  animation: chat-status-bubble-in 0.28s cubic-bezier(0.25, 0.9, 0.3, 1);\r\n}\r\n\r\n@keyframes chat-status-bubble-in {\r\n  from { opacity: 0; transform: translateY(4px); }\r\n  to   { opacity: 1; transform: none; }\r\n}\r\n\r\n/* NOTE: the .chat-status-message block itself NEVER animates on collapse —\r\n   it contains the avatar, and the avatar must not move or fade a single\r\n   pixel during the hand-off to the answer. Only the inner bubble folds. */\r\n\r\n.chat-status-timeline {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;              /* the bot bubble look — seamless hand-off */\r\n  border-radius: 8px;\r\n  padding: 9px 12px;\r\n  max-width: 70%;\r\n  min-width: 230px;\r\n  max-height: 280px;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Answer hand-off: the bubble fades out as ONE piece (calm, no per-row\r\n   choreography), then folds shut while already invisible — so the visible\r\n   part of the exit is a pure fade, and the height change happens off-eye.\r\n   Total ends at ~440ms; collapseStatus's timer (460ms) swaps in the answer\r\n   right after. */\r\n.chat-status-timeline.collapsing {\r\n  max-height: 0;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n  opacity: 0;\r\n  transition: opacity 0.24s ease,\r\n              max-height 0.2s ease 0.24s, padding 0.2s ease 0.24s;\r\n}\r\n\r\n.chat-status-step {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  height: 26px;                  /* FIXED row height — the no-jump contract */\r\n  flex-shrink: 0;\r\n  font-size: 13px;\r\n  color: #6b6b76;\r\n  white-space: nowrap;           /* rows never wrap, details ellipsize */\r\n  overflow: hidden;\r\n  /* Entry animates OPACITY/TRANSFORM ONLY — never height. An animated height\r\n     desynchronizes the spacer (it measures 0px at insert, the row then grows\r\n     unwatched, the next recalc snaps back) and the scrollbar thumb dances\r\n     through every status update. */\r\n  animation: chat-status-row-in 0.2s ease;\r\n}\r\n\r\n@keyframes chat-status-row-in {\r\n  from { opacity: 0; transform: translateY(-4px); }\r\n  to   { opacity: 1; transform: none; }\r\n}\r\n\r\n.chat-status-icon {\r\n  width: 15px;\r\n  height: 15px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.chat-status-icon svg {\r\n  animation: chat-status-check-pop 0.22s cubic-bezier(0.3, 1.4, 0.5, 1);\r\n}\r\n\r\n@keyframes chat-status-check-pop {\r\n  from { transform: scale(0.4); opacity: 0; }\r\n  to   { transform: scale(1); opacity: 1; }\r\n}\r\n\r\n.chat-status-step.done {\r\n  color: #9a9aa5;\r\n}\r\n\r\n.chat-status-step.done .chat-status-icon {\r\n  opacity: 0.6;\r\n}\r\n\r\n/* Newest step: soft left-to-right shimmer across the label text. */\r\n.chat-status-step.active .chat-status-label {\r\n  background: linear-gradient(90deg, #55555e 0%, #55555e 40%, #b9a8f7 50%, #55555e 60%, #55555e 100%);\r\n  background-size: 200% 100%;\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  animation: chat-status-shimmer 1.6s linear infinite;\r\n}\r\n\r\n@keyframes chat-status-shimmer {\r\n  from { background-position: 200% 0; }\r\n  to   { background-position: 0% 0; }\r\n}\r\n\r\n.chat-status-pulse {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #5616ea;\r\n  box-shadow: 0 0 0 0 rgba(86, 22, 234, 0.35);\r\n  animation: chat-status-pulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes chat-status-pulse {\r\n  0%   { transform: scale(0.8); box-shadow: 0 0 0 0 rgba(86, 22, 234, 0.35); }\r\n  55%  { transform: scale(1);   box-shadow: 0 0 0 5px rgba(86, 22, 234, 0); }\r\n  100% { transform: scale(0.8); box-shadow: 0 0 0 0 rgba(86, 22, 234, 0); }\r\n}\r\n\r\n/* The step's detail — the agent's composed search query, typed out live.\r\n   Inline with its row, ellipsized: it can never change the row's height. */\r\n.chat-status-detail {\r\n  font-size: 12.5px;\r\n  font-style: italic;\r\n  color: #8a8a95;\r\n  margin-left: 2px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  min-width: 0;\r\n}\r\n\r\n.chat-status-step.active .chat-status-detail {\r\n  color: #75758a;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
